import { render, staticRenderFns } from "./edit-fire-policy-form.vue?vue&type=template&id=5f61570c&scoped=true&"
import script from "./edit-fire-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-fire-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61570c",
  null
  
)

export default component.exports